import { Language } from "../../../../../providers/language/types";
import { CMS_API_URL } from "../../../../../shared/constants/api";

export type FormData = {
  name: string;
  company: string;
  email: string;
  message: string;
};

export const sendFormData = async (formData: FormData, language: Language) => {
  const payload = new FormData();
  payload.append("FirstName", formData.name);
  payload.append("Company", formData.company);
  payload.append("Email", formData.email);
  payload.append(
    "Message",
    formData.message !== "" ? formData.message : "empty",
  ); // Need fix in backend
  payload.append("TimeZoneOffset", String(new Date().getTimezoneOffset()));
  payload.append("Language", language ?? "en");

  const response = await fetch(`${CMS_API_URL}/api/contact-us`, {
    method: "POST",
    headers: {
      Accept: "*/*",
    },
    body: payload,
  });

  return response;
};
